/**
 * サンプルクラス
 * @constructor
 */
class AchievementSlider {

  constructor() {
    this._addClassNameVal = 'is-active';
    this.init();
  }

  /**
  * 初期化メソッド
  * ページ内に指定された要素（.js-achievementSlider）が存在する場合、トップパララックスを実行する
  */
  init() {
    const slider = document.querySelector('.js-achievementSlider');
    if (slider) {
      this.achievementSlider(slider);
    }
  }
  achievementSlider(slider) {
    const slides = slider.querySelectorAll('.p-achievementSlide__imgBoxItem');
    const texts = slider.querySelectorAll('.p-achievementSlide__textBoxItem');
    const addClassNameVal = this._addClassNameVal;

    // ページネーションの要素を取得
    const prevButton = slider.querySelector('.p-achievementSlide__prevButton');
    const nextButton = slider.querySelector('.p-achievementSlide__nextButton');
    const pageNumbers = slider.querySelectorAll('.p-achievementSlide__pageNumber');

    let currentSlide = 0;

    function showSlide(slideIndex) {
      slides.forEach((slide, index) => {
        slide.classList.toggle(addClassNameVal, index === slideIndex);
        texts[index].classList.toggle(addClassNameVal, index === slideIndex);
      });

      // .page-number の is-active クラスをトグル
      pageNumbers.forEach((pageNumber, index) => {
        pageNumber.classList.toggle(addClassNameVal, index === slideIndex);
      });
    }

    // 次のスライドへ移動
    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }

    // 前のスライドへ移動
    function prevSlide() {
      currentSlide = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(currentSlide);
    }

    // 前のボタンをクリックしたときの処理
    prevButton.addEventListener('click', () => {
      prevSlide();
    });

    // 次のボタンをクリックしたときの処理
    nextButton.addEventListener('click', () => {
      nextSlide();
    });

    // ページ番号をクリックしたときの処理
    pageNumbers.forEach((pageNumber, index) => {
      pageNumber.addEventListener('click', function () {
        currentSlide = index;
        showSlide(currentSlide);
      });
    });


    // 初期表示
    showSlide(currentSlide);

    // let slideInterval = setInterval(nextSlide, 2500);

    // slideInterval をリセットする関数
    function resetSlideInterval() {
      clearInterval(slideInterval);
      // 2.5秒ごとに次のスライドを表示
      slideInterval = setInterval(nextSlide, 2500);
    }
  }
}

export default AchievementSlider;
